
import { Contact, Sale, SaleType } from "@/models/base";
import { BookYearService } from "@/services/book-year-service";
import { SaleService } from "@/services/sale-service";
import { SalesSaveAsData } from "@/utils/documents/sales-save-as-data";
import { ISelectItem } from "winfakt-vue-components";
import AppSelectJournal from "@/components/SelectJournal.vue";
import AppContactSearch from "@/components/contacts/ContactSearch.vue";
import { VatService } from "@/services/vat-service";
import { FormLike } from "winfakt-vue-components/src/mixins/form-like";
import AppErrorMessage from "@/components/common/ErrorMessageBox.vue";
import { UserConfigService } from "@/services";

export default FormLike.extend({
	data(){
		return {
			data: new SalesSaveAsData(),
			bookyears: [] as number[],
			state: 1,
			contact: null as null | Contact,
			saveAsTypeIdError: "",
			isSubmitting: false
		};
	},
	props: {
		sales: {
			type: Array as ()=>Sale[],
			required: true
		}
	},
	computed: {
		bookYearItems():ISelectItem<number>[]{
			return BookYearService.bookYears.map(b=>{
				return {
					text: `${b.Year}`,
					value: b.Year
				};
			});
		},
		contactGroupId():number{
			for (let sale of this.sales){
				let saleType:SaleType | undefined = sale.Type;
				if (!saleType) {
					saleType = SaleService.getTypes().find(t=>t.ID == sale.TypeID);
				}
				if (!saleType) {
					continue;
				}
				return saleType.ContactGroupID;
			}
			throw new Error("Contact group not found");
		},
		saleTypeItems():ISelectItem<number>[]{
			let result:ISelectItem<number>[] = SaleService.getTypes(this.contactGroupId).filter(t=>t.ID != 10).map(t=>{
				return {
					text: t.Name.getTranslation(this.$i18n.locale),
					value: t.ID
				};
			});

			result.unshift({
				text: this.$ct("original-type").toString(),
				value: 0
			});
			return result;
		},
		vatRegimeItems():ISelectItem<number>[]{
			let regimeCount = VatService.getVatRegimeCount();
			let items = [] as ISelectItem<number>[];
			for (let i = 0; i < regimeCount; i++) {
				items.push({
					text: this.$ct("common.vat-regimes." + (i + 1)).toString(),
					value: i + 1
				});
			}
			return items;
		},
		hasDeletePermissions():boolean{
			return UserConfigService.hasCurrentUserPermission((p)=>p.SalePermissions.hasDeletePermissions());
		},
		useTodaysDateDisabled():boolean{
			if (this.data.saveAs1Document) {
				return true;
			}
			if (this.data.toBookYear == this.sales[0].BookYear) {
				return true;
			}
			return false;
		},
		keepSameNumbersDisabled():boolean {
			if (this.data.saveAs1Document) {
				return true;
			}
			if (this.data.toBookYear == this.sales[0].BookYear) {
				return true;
			}
			if (this.data.saveAsTypeId != 0) {
				return true;
			}
			return false;
		}
	},
	watch: {
		contact: {
			immediate: true,
			handler(){
				if (this.contact){
					this.data.clientID = this.contact.ID;
				}else{
					this.data.clientID = 0;
				}
			}
		},
		data: {
			deep: true,
			handler(){
				this.validate();
			}
		},
		hasDeletePermissions: {
			immediate: true,
			handler(){
				if (!this.hasDeletePermissions){
					this.data.deleteOriginalDocuments = false;
				}
			}
		},
		keepSameNumbersDisabled(){
			if (this.keepSameNumbersDisabled) {
				this.data.keepSameNumbers = false;
			}
		},
		useTodaysDateDisabled(){
			if (this.useTodaysDateDisabled) {
				this.data.useTodaysDate = false;
			}
		}
	},
	methods: {
		extendValidate(){
			this.isValid = true;
			this.saveAsTypeIdError = "";
			for (let sale of this.sales){
				if (sale.TypeID == 1 && this.data.saveAsTypeId <= 1){
					this.isValid = false;
					this.saveAsTypeIdError = "error-cannot-save-invoice-as-invoice";
					break;
				}
			}
		},
		close(){
			this.state = 1;
			this.data = new SalesSaveAsData();
			this.$emit("close");
		},
		async submit(){
			if (this.isSubmitting) return;
			this.isSubmitting = true;
			try{
				this.validate();
				if (!this.isValid) return;
				if (!this.data.saveAs1Document || this.state == 2) {
					this.data.saleIds = this.sales.map(s=>s.ID);
					await SaleService.saveSalesAs(this.data);
					this.$wf.notify(this.$ct("sale-save-as-started"), "info", 3000, "info-circle");
					this.$emit("refresh");
					this.close();
					return;
				}
				this.state = 2;
			}catch(err){
			}finally{
				this.isSubmitting = false;
			}
		}
	},
	components: {
		AppSelectJournal,
		AppContactSearch,
		AppErrorMessage
	},
	i18nEx: {
		componentPrefix: "components.sales"
	}
});
